import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t, i18n } = useTranslation();
  
  return (
    <footer className="bg-primary-900 dark:bg-[rgb(var(--background-secondary))] text-white dark:text-[rgb(var(--foreground))] mt-auto border-t border-primary-800 dark:border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">CLAROCLAIM</h3>
            <p className="text-primary-100 dark:text-[rgb(var(--muted-foreground))] text-sm">
              {t('footer.company.description')}
            </p>
            
            {/* TrustBox widget */}
            <div 
              className="trustpilot-widget mt-6" 
              data-locale="de-DE" 
              data-template-id="53aa8807dec7e10d38f59f32" 
              data-businessunit-id="693bcbf38e89501ab005c313" 
              data-style-height="150px" 
              data-style-width="100%" 
              data-theme="dark"
              data-token="d256a2c6-c945-418c-9117-b58261f1f7e3"
            >
              <a href="https://de.trustpilot.com/review/claroclaim.de" target="_blank" rel="noopener noreferrer">Trustpilot</a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-semibold mb-4">{t('footer.quickLinks.title')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to={`/${i18n.language}/`} className="text-neutral-300 dark:text-neutral-400 hover:text-white dark:hover:text-neutral-200 transition-colors">
                  {t('footer.quickLinks.home')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-base font-semibold mb-4">{t('footer.legal.title')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to={`/${i18n.language}/privacy`} className="text-neutral-300 dark:text-neutral-400 hover:text-white dark:hover:text-neutral-200 transition-colors">
                  {t('footer.legal.privacy')}
                </Link>
              </li>
              <li>
                <Link to={`/${i18n.language}/terms`} className="text-neutral-300 dark:text-neutral-400 hover:text-white dark:hover:text-neutral-200 transition-colors">
                  {t('footer.legal.terms')}
                </Link>
              </li>
              <li>
                <Link to={`/${i18n.language}/imprint`} className="text-neutral-300 dark:text-neutral-400 hover:text-white dark:hover:text-neutral-200 transition-colors">
                  {t('footer.legal.imprint')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base font-semibold mb-4">{t('footer.contact.title')}</h4>
            <ul className="space-y-2 text-sm text-neutral-300 dark:text-neutral-400 mb-6">
              <li>
                <a href="mailto:amazon@claroclaim.de" className="hover:text-white dark:hover:text-neutral-200 transition-colors">
                  amazon@claroclaim.de
                </a>
              </li>
              <li>
                <a href="tel:+4969348687771" className="hover:text-white dark:hover:text-neutral-200 transition-colors">
                  069 348 68 77 71
                </a>
              </li>
              <li>
                Weserstr. 4<br />
                60329 Frankfurt
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-neutral-800 dark:border-neutral-700">
          <p className="text-xs text-neutral-300 dark:text-neutral-400 text-center mb-6 max-w-4xl mx-auto leading-relaxed">
            {t('home.legal_disclaimer')}
          </p>
          <div className="text-center text-sm text-neutral-300 dark:text-neutral-400">
            {t('footer.copyright')}
          </div>
        </div>
      </div>
    </footer>
  );
}